export const getCandidate = (state) => state.candidate
